// Imgix URL for desktop hero image preload (aligned with main column width).
export default function buildPdpDesktopHeroLcpUrl(rawSrc) {
  if (!rawSrc || typeof rawSrc !== 'string') {
    return null;
  }

  const isImgix = rawSrc.includes('imgix.net') || rawSrc.includes('imgix.com');

  if (!isImgix) {
    return rawSrc;
  }

  try {
    const url = new URL(rawSrc);
    const params = url.searchParams;

    if (!params.has('auto')) {
      params.set('auto', 'format,compress');
    }

    if (!params.has('w')) {
      params.set('w', '1800');
    }

    if (!params.has('fit')) {
      params.set('fit', 'max');
    }

    url.search = params.toString();

    return url.toString();
  } catch (error) {
    return rawSrc;
  }
}
